export default "__VITE_ASSET__D14iYLif__";